/**
 * <ChilletCoin> — a coin component for the Gambling Coinflip view.
 *
 * The actual flip animation is a pre-rendered GIF (heads-landing or
 * tails-landing) supplied by the user. We just show the right GIF
 * during the toss and switch to a static PNG of the appropriate face
 * for the idle / settled-result states.
 *
 * Props:
 *   side        "heads" | "tails" | "idle"  — static rest state
 *   flipping    boolean                      — play the toss GIF
 *   outcome     "heads" | "tails"            — which GIF to play
 *                                              (must be known at flip start)
 *   size        number (default 220)         — pixel diameter
 */
const HEADS = "/icons/chillet_coin_heads.png";
const TAILS = "/icons/chillet_coin_tails.png";
const FLIP_HEADS = "/icons/coinflip_heads.gif";
const FLIP_TAILS = "/icons/coinflip_tails.gif";

export function ChilletCoin({
  side = "idle",
  flipping = false,
  outcome = "heads",
  size = 220,
  className = "",
  ...rest
}) {
  const classNames = ["chillet-coin"];
  if (flipping) classNames.push("is-flipping");
  else if (side === "heads") classNames.push("is-heads");
  else if (side === "tails") classNames.push("is-tails");
  else classNames.push("is-idle");
  if (className) classNames.push(className);

  let src;
  if (flipping) {
    // Cache-bust on each flip start so the GIF restarts from frame 0
    // instead of reusing the browser's existing decoded copy mid-loop.
    const cb = Math.floor(Date.now() / 100);
    src = `${outcome === "tails" ? FLIP_TAILS : FLIP_HEADS}?t=${cb}`;
  } else if (side === "tails") {
    src = TAILS;
  } else {
    src = HEADS;
  }

  return (
    <div
      className={classNames.join(" ")}
      style={{ width: size, height: size }}
      {...rest}
    >
      <img
        src={src}
        alt=""
        className="chillet-coin__img"
        draggable="false"
      />
    </div>
  );
}

export default ChilletCoin;
